import React, { Component } from 'react';

import imagen  from '../../../assets/img/header-banner-1.png';

class SubItem1 extends Component {
    state = {  }
    render() { 
        return (
            <div className="header" id = "item1">
                <div className="header-banner2" style={{backgroundImage: `url(${imagen})`, paddingLeft: "10%", paddingRight: "10%", paddingTop: 40, paddingBottom: 40}}>
                    <div style={{color:"a80012", fontSize: 30}} className="fuente-monserrat">A quiénes va dirigida</div>
                    <div align="justify" style={{color:"fff", fontSize: 16}} className="custom-mt-10 fuente-monserrat">
                        La carrera de Diseño de Moda va dirigida a bachilleres creativos, innovadores y proactivos, con intereses e inquietudes para iniciar su formación profesional en el campo del diseño, gestión, comunicación y producción del sector Moda. Que sienta pasión por la moda y tenga sensibilidad para el diseño, la cultura y el arte. Con capacidad crítica, organizativa y de trabajo en equipo, con facilidad para el uso de nuevas tecnologías y habilidad para manejar y procesar material y avances tecnológicos en su área de trabajo.
                    </div>
                </div>
            </div>
        );
    }
}
 
export default SubItem1;


// WEBPACK FOOTER //
// ./src/site/Componentes/DiseñoModa/SubItem1.jsx